/**
 * Metadata-only integration types
 * These integrations use only metadata (no credentials)
 * and are managed exclusively by Super Admins
 */
export var MetadataOnlyIntegrationType;
(function (MetadataOnlyIntegrationType) {
    MetadataOnlyIntegrationType["RENT_MANAGER"] = "RENT_MANAGER";
})(MetadataOnlyIntegrationType || (MetadataOnlyIntegrationType = {}));
//# sourceMappingURL=metadata-only-integration-type.js.map